import {
  ProductFeedbackFeature,
  useSubmitFeedback,
} from "@/hooks/use-submit-feedback";

/** The parameters accepted by the product feedback endpoint, excluding the auto-filled context. */
type ProductFeedbackParams = {
  /** A broad grouping by feature. */
  feature: ProductFeedbackFeature;

  /** The question asked to the user. */
  question: string;

  /** The rating given by the user (1-5 - where 5 is the best). */
  rating: number;

  /** The optional, user-provided answer to the feedback question. */
  message?: string;

  /**
   * Additional technical information for the feedback. Use for not directly user-provided information that helps to convey the context,
   * e.g. an order ID to which this feedback was given for.
   */
  additionalInfo?: string;

  /** Whether the user has given permission to be contacted about the feedback. */
  hasUserAllowedContact?: boolean;
};

/**
 * @returns a callback function to submit product feedback, showing a toast when the operation fails.
 */
export function useSubmitProductFeedback(): (
  feedbackContent: ProductFeedbackParams,
) => Promise<boolean> {
  return useSubmitFeedback<ProductFeedbackParams>();
}
